import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { IOSListItem, IOSListGroup, IOSButton } from '../components/ios';
import { settingsAPI } from '../services/api';
import toast from 'react-hot-toast';
import {
  HiOutlineUser,
  HiOutlineShieldCheck,
  HiOutlineCollection,
  HiOutlineCog,
  HiOutlineLogout,
} from 'react-icons/hi';

function Profile() {
  const { t } = useTranslation();
  const { user, logout, setUser } = useAuth();
  const navigate = useNavigate();
  const [systemVersion, setSystemVersion] = useState('1.4.1');

  useEffect(() => {
    loadSystemVersion();
  }, []);

  const loadSystemVersion = async () => {
    try {
      const res = await settingsAPI.getSystemVersion();
      setSystemVersion(res.data.version);
    } catch (error) {
      console.error('Error loading system version:', error);
    }
  };

  const handleEditProfile = () => {
    navigate('/profile/edit');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
    toast.success(t('auth.logoutSuccess') || 'Logout realizado');
  };



  return (
    <div className="profile-page">
      {/* Header do Perfil */}
      <div className="profile-header">
        <div className="profile-avatar">
          {user?.username?.charAt(0).toUpperCase()}
        </div>
        <h2 className="profile-name">{user?.username}</h2>
        <p className="profile-email">{user?.email}</p>
        <span className={`profile-badge ${user?.is_admin ? 'profile-badge--admin' : ''}`}>
          {user?.is_admin ? t('navigation.administrator') : t('navigation.user')}
        </span>
      </div>

      {/* Configurações */}
      <IOSListGroup title={t('settings.title')}>
        <IOSListItem
          icon={HiOutlineUser}
          title={t('profile.editProfile')}
          onClick={handleEditProfile}
          chevron
        />
      </IOSListGroup>

      {/* Admin (só aparece se for admin) */}
      {user?.is_admin && (
        <IOSListGroup title={t('navigation.administration')}>
          <IOSListItem
            icon={HiOutlineShieldCheck}
            title={t('navigation.users')}
            onClick={() => navigate('/admin/users')}
            chevron
          />
          <IOSListItem
            icon={HiOutlineCollection}
            title={t('navigation.series')}
            onClick={() => navigate('/admin/series')}
            chevron
          />
          <IOSListItem
            icon={HiOutlineCog}
            title={t('navigation.settings')}
            onClick={() => navigate('/admin/settings')}
            chevron
          />
        </IOSListGroup>
      )}

      {/* Logout */}
      <div style={{ marginTop: '32px', padding: '0 16px' }}>
        <IOSButton
          variant="destructive"
          fullWidth
          onClick={handleLogout}
          icon={HiOutlineLogout}
        >
          {t('navigation.logout')}
        </IOSButton>
      </div>

      {/* App Info */}
      <div className="profile-footer">
        <p>My Series v{systemVersion}</p>
        <p>© 2026 My Series Team</p>
      </div>
    </div>
  );
}

export default Profile;
